<template>
  <div class="provinceCityAreaSelect">
    <el-form-item prop="province">
      <el-select
        v-model="formTool.province"
        size="small"
        clearable
        placeholder="请选择省"
        @change="provinceBtn"
        style="width: 120px"
      >
        <el-option
          v-for="(item, index) in provinceData"
          :key="index"
          :label="item.rname"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item prop="city">
      <el-select
        v-model="formTool.city"
        size="small"
        clearable
        placeholder="请选择市"
        @change="cityBtn"
        style="width: 120px"
      >
        <el-option
          v-for="(item, index) in cityData"
          :key="index"
          :label="item.rname"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item prop="area">
      <el-select
        v-model="formTool.area"
        size="small"
        clearable
        placeholder="请选择区"
        @change="areaBtn"
        style="width: 120px"
      >
        <el-option
          v-for="(item, index) in areaData"
          :key="index"
          :label="item.rname"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
  </div>
</template>
<script>
import {
  regionProvince,
  regionCity,
  regionArea,
} from "@/api/merchantsettlement/index";
export default {
  name: "provinceCityAreaSelect",
  data() {
    return {
      formTool: {
        province: "",
        city: "",
        area: "",
      },
      provinceData: [],
      cityData: [],
      areaData: [],
      rules: {
        province: [{ required: true, message: "请选择省", trigger: "change" }],
      },
    };
  },
  methods: {
    initData() {
      this.getProvince();
    },
    getData() {
      return this.formTool;
    },
    getProvince() {
      regionProvince().then((res) => {
        if (res.code === 0) {
          this.provinceData = res.data;
        }
      });
    },
    provinceBtn(item) {
      this.cityData = [];
      this.areaData = [];
      if (!item) {
        this.formTool.city = ``;
        this.formTool.area = ``;
      } else {
        regionCity(item).then((res) => {
          this.cityData = res.data;
          this.formTool.city = ``;
          this.formTool.area = ``;
        });
      }
    },
    cityBtn(item) {
      this.areaData = [];
      if (!item) {
        this.formTool.area = ``;
      } else {
        regionArea(item).then((res) => {
          this.formTool.area = "";
          this.areaData = res.data;
        });
      }
    },
    areaBtn(item) {
      if (!item) {
        this.formTool.area = ``;
      } else {
      }
    },
  },
};
</script>
<style scoped lang="scss">
.provinceCityAreaSelect {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
